import { Pipe, PipeTransform } from '@angular/core';
import { CoinUser, Employee, EmployeeLight, EmployeeSlim } from '@coin/shared/core/util-models';

@Pipe({
  name: 'employeeName',
  standalone: true
})
export class EmployeeNamePipe implements PipeTransform {
  public transform(
    value: Employee | CoinUser | EmployeeLight | EmployeeSlim,
    mode: 'never' | 'ifAvailable' | 'preferredAndFull' = 'ifAvailable'
  ): string {
    return EmployeeNamePipe.formatEmployee(value, mode);
  }

  public static formatEmployee(
    employee: Employee | CoinUser | EmployeeLight | EmployeeSlim,
    mode: 'never' | 'ifAvailable' | 'preferredAndFull' = 'ifAvailable'
  ): string {
    if (!employee) return '';
    const firstName =
      'headFirstname' in employee
        ? employee.headFirstname
        : 'firstname' in employee
          ? employee.firstname
          : 'firstName' in employee
            ? employee.firstName
            : '';
    const lastName =
      'headLastname' in employee
        ? employee.headLastname
        : 'lastname' in employee
          ? employee.lastname
          : 'lastName' in employee
            ? employee.lastName
            : '';
    const title = 'title' in employee ? employee.title : '';
    const lastNamePrefix = 'lastNamePrefix' in employee ? employee.lastNamePrefix : '';
    const lastnamePrefix = 'lastnamePrefix' in employee ? employee.lastnamePrefix : '';

    let displayName = firstName;
    if (mode === 'ifAvailable' || mode === 'preferredAndFull') {
      if ('preferredFirstname' in employee && employee.preferredFirstname?.trim()) {
        displayName = employee?.preferredFirstname;
      }
    }
    return [title, displayName, lastNamePrefix, lastnamePrefix, lastName].filter(Boolean).join(' ').trim();
  }
}
